import { gql } from '@generated/gql';

const selectQuote = gql(`
  mutation SelectQuote($quoteInput: SelectQuoteInput!){
    selectQuote(input: $quoteInput) {
      ...BundleBasket
    }
  }
`);

const deselectQuote = gql(`
  mutation DeselectQuote($quoteInput: DeselectQuoteInput!) {
    deselectQuote(input: $quoteInput) {
      ...BundleBasket
    }
  }
`);

const selectQuotes = gql(`
  mutation SelectQuotes($quoteInput: SelectQuotesInput!) {
    selectQuotes(input: $quoteInput) {
      ...BundleBasket
    }
  }
`);

const deselectQuotes = gql(`
  mutation DeselectQuotes($quoteInput: DeselectQuotesInput!) {
    deselectQuotes(input: $quoteInput) {
      ...BundleBasket
    }
  }
`);

export { selectQuote, deselectQuote, selectQuotes, deselectQuotes };
